<template>
  <div class="api-documentation">
    <a-page-header
      :title="t.pageTitle"
      :sub-title="t.commonRequestPath"
    />

    <a-card :title="t.signatureRule" style="margin-top: 20px;">
      <p>{{ t.signatureDescription }}</p>
    </a-card>

    <a-card :title="t.apiList" style="margin-top: 20px;">
      <a-collapse v-model="activeKey">
        <!-- 获取静态套餐列表 -->
        <a-collapse-panel :header="t.getStaticPackageList" key="1">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/getStaticPackageList</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid+nativeType+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "uid": 315,\n  "nativeType": "1",\n  "sign": "908e6e894033eb62adcb987f9210fe04"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="getStaticPackageParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200,\n  "data": [\n    {\n      "uid": 315,\n      "username": "C4I6E7E3Y0U0",\n      "password": "c7z2X8W1n4i9",\n      "ip": "1.1.1.1",\n      "port": "5555",\n      "creatTime": "2025-01-06T14:21:07.000+08:00",\n      "overTime": "2025-02-05T14:21:07.000+08:00",\n      "iso": "US"\n    }\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="getStaticPackageResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 获取静态套餐原生的国家列表 -->
        <a-collapse-panel :header="t.getStaticNativeCountryList" key="2">
          <div class="api-detail">
            <div class="api-path">GET /stage-api/uapi/openapi/getStaticNativeCountryList</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
uid=315&sign="908e6e894033eb62adcb987f9210fe04"
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="getStaticNativeCountryListParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200,\n  "data": [\n    {\n      "id": 1,\n      "country": "United States",\n      "countryZh": "美国",\n      "countryCode": "US"\n    },\n    {\n      "id": 2,\n      "country": "Malaysia",\n      "countryZh": "马来西亚",\n      "countryCode": "MY"\n    }\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="getStaticNativeCountryListResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 获取静态套餐广播的国家列表 -->
        <a-collapse-panel :header="t.getStaticBroadcastCountryList" key="3">
          <div class="api-detail">
            <div class="api-path">GET /stage-api/uapi/openapi/getStaticBroadcastCountryList</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid+key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
uid=315&sign="908e6e894033eb62adcb987f9210fe04"
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="getStaticBroadcastCountryListParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "操作成功",\n  "code": 200,\n  "data": [\n    {\n      "id": 1,\n      "country": "United States",\n      "countryZh": "美国",\n      "countryCode": "US"\n    },\n    {\n      "id": 2,\n      "country": "Canada",\n      "countryZh": "加拿大",\n      "countryCode": "CA"\n    }\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="getStaticBroadcastCountryListResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 根据国家查询城市列表 -->
        <a-collapse-panel :header="t.getStaticCityList" key="4">
          <div class="api-detail">
            <div class="api-path">GET /stage-api/uapi/openapi/getStaticCityList</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid + country_code + proxies_format + proxies_type + purpose_web + key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
uid=315&country_code="US"&proxies_format="2"&proxies_type="Premium (ISP) proxies"&purpose_web="TikTok"&sign="908e6e894033eb62adcb987f9210fe04"
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="getStaticCityListParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "code": 200,\n  "msg": "操作成功",\n  "data": [\n    {\n      "proxies_type": "Premium (ISP) proxies",\n      "proxies_format": 2,\n      "purpose_web": "TikTok",\n      "country_list": [\n        {\n            "continents_id": "1816068478248030208",\n            "continents_name": "North America",\n            "country_code": "US",\n            "city_id": "40960",\n            "city_name": "Philadelphia",\n            "number": 79\n        },\n        {\n            "continents_id": "1816068478248030208",\n            "continents_name": "North America",\n            "country_code": "US",\n            "city_id": "81004",\n            "city_name": "Los Angeles",\n            "number": 268\n        }\n      ]\n    }\n  ]\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="getStaticCityListResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 购买原生静态住宅 -->
        <a-collapse-panel :header="t.purchaseStaticPackageNative" key="5">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/purchaseStaticPackageNative</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid + count + protocolsType + country + cityName + timePeriod + purposeWeb + key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n    "uid": 315,\n    "count": "1",\n    "protocolsType":"2",\n    "country": "US",\n    "cityName": "Los Angeles",\n    "timePeriod": "30",\n    "purposeWeb":"TikTok",\n    "sign": "8b65895f434bdbd260f0699083dd8361"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="purchaseStaticPackageNativeParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "购买静态套餐成功",\n  "code": 200\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="commonResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 购买广播静态住宅 -->
        <a-collapse-panel :header="t.purchaseStaticPackageBroadcast" key="6">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/purchaseStaticPackageBroadcast</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid + count + protocolsType + country + cityName + timePeriod + purposeWeb + key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n    "uid": 315,\n    "count": "1",\n    "protocolsType":"2",\n    "country": "US",\n    "cityName": "Los Angeles",\n    "timePeriod": "30",\n    "purposeWeb":"TikTok",\n    "sign": "8b65895f434bdbd260f0699083dd8361"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="purchaseStaticPackageBroadcastParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "购买静态套餐成功",\n  "code": 200\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="commonResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
        
        <!-- 续费静态住宅 -->
        <a-collapse-panel :header="t.pointRenewalStaticPackage" key="7">
          <div class="api-detail">
            <div class="api-path">POST /stage-api/uapi/openapi/pointRenewalStaticPackage</div>
            <div class="api-signature"><strong>{{ t.signatureRule }}：</strong>sign = md5(uid + ips + num + key)</div>
            <a-divider />
            
            <h4>{{ t.requestExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n    "uid": 315,\n    "ips": ["1.1.1.2", "1.1.1.3"],\n    "num": 30,\n    "sign": "8b65895f434bdbd260f0699083dd8361"\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.requestParams }}</h4>
            <a-table
              :columns="requestParamsColumns"
              :data-source="pointRenewalStaticPackageParams"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseExample }}</h4>
            <pre style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; overflow-x: auto;"><code class="json">
{\n  "msg": "续费静态套餐成功",\n  "code": 200\n}
            </code></pre>
            <a-divider />
            
            <h4>{{ t.responseResult }}</h4>
            <a-table
              :columns="responseResultColumns"
              :data-source="responseResults"
              :pagination="false"
              bordered
            />
            <a-divider />
            
            <h4>{{ t.responseDataStructure }}</h4>
            <a-table
              :columns="responseDataStructureColumns"
              :data-source="commonResponseData"
              :pagination="false"
              bordered
            />
          </div>
        </a-collapse-panel>
      </a-collapse>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'StaticApiDoc',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.currentLanguage : 'en';
    },
    t() {
      const lang = this.currentLanguage;
      return {
        pageTitle: lang === 'zh' ? '静态API接口文档' : 'Static API Documentation',
        commonRequestPath: lang === 'zh' ? '公共请求路径：https://www.proxylink.net/' : 'Common Request Path: https://www.proxylink.net/',
        signatureRule: lang === 'zh' ? '签名规则' : 'Signature Rule',
        signatureDescription: lang === 'zh' ? 'sign: 请求参数按ascii码排序，然后参数+key获取signstr，md5(signStr)获得签名字段sign' : 'sign: Request parameters are sorted by ASCII code, then parameters+key to get signstr, md5(signStr) to get the signature field sign',
        apiList: lang === 'zh' ? 'API列表' : 'API List',
        
        getStaticPackageList: lang === 'zh' ? 'POST 获取静态套餐列表' : 'POST Get Static Package List',
        getStaticNativeCountryList: lang === 'zh' ? 'GET 获取静态套餐原生的国家列表' : 'GET Get Static Package Native Country List',
        getStaticBroadcastCountryList: lang === 'zh' ? 'GET 获取静态套餐广播的国家列表' : 'GET Get Static Package Broadcast Country List',
        getStaticCityList: lang === 'zh' ? 'GET 根据国家查询城市列表' : 'GET Query City List by Country',
        purchaseStaticPackageNative: lang === 'zh' ? 'POST 购买原生静态住宅' : 'POST Purchase Native Static Residential',
        purchaseStaticPackageBroadcast: lang === 'zh' ? 'POST 购买广播静态住宅' : 'POST Purchase Broadcast Static Residential',
        pointRenewalStaticPackage: lang === 'zh' ? 'POST 续费静态住宅' : 'POST Renew Static Residential',
        
        requestExample: lang === 'zh' ? '请求示例' : 'Request Example',
        requestParams: lang === 'zh' ? '请求参数' : 'Request Parameters',
        responseExample: lang === 'zh' ? '返回示例' : 'Response Example',
        responseResult: lang === 'zh' ? '返回结果' : 'Response Result',
        responseDataStructure: lang === 'zh' ? '返回数据结构' : 'Response Data Structure',
        
        // Table headers
        name: lang === 'zh' ? '名称' : 'Name',
        location: lang === 'zh' ? '位置' : 'Location',
        type: lang === 'zh' ? '类型' : 'Type',
        required: lang === 'zh' ? '必选' : 'Required',
        description: lang === 'zh' ? '说明' : 'Description',
        code: lang === 'zh' ? '状态码' : 'Code',
        message: lang === 'zh' ? '说明' : 'Message',
        model: lang === 'zh' ? '数据模型' : 'Data Model'
      };
    },
    requestParamsColumns() {
      return [
        { title: this.t.name, dataIndex: 'name', key: 'name' },
        { title: this.t.location, dataIndex: 'location', key: 'location' },
        { title: this.t.type, dataIndex: 'type', key: 'type' },
        { title: this.t.required, dataIndex: 'required', key: 'required' },
        { title: this.t.description, dataIndex: 'description', key: 'description' }
      ];
    },
    responseResultColumns() {
      return [
        { title: this.t.code, dataIndex: 'code', key: 'code' },
        { title: this.t.message, dataIndex: 'message', key: 'message' },
        { title: this.t.model, dataIndex: 'model', key: 'model' }
      ];
    },
    responseDataStructureColumns() {
      return [
        { title: this.t.name, dataIndex: 'name', key: 'name' },
        { title: this.t.type, dataIndex: 'type', key: 'type' },
        { title: this.t.required, dataIndex: 'required', key: 'required' },
        { title: this.t.description, dataIndex: 'description', key: 'description' }
      ];
    }
  },
  data() {
    // Default to English for initial data
    const defaultLang = 'en';
    
    return {
      activeKey: ['1'],
      responseResults: [
        { key: '1', code: '200', message: defaultLang === 'zh' ? '成功' : 'Success', model: 'Inline' }
      ],
      
      // 获取静态套餐列表请求参数
      getStaticPackageParams: [
        { key: '1', name: 'nativeType', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '传1就是查询原生静态套餐列表，传0就是查询广播静态套餐列表' : 'Pass 1 to query native static package list, pass 0 to query broadcast static package list' },
        { key: '2', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '主账户的uid' : 'Main account uid' },
        { key: '3', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 获取静态套餐列表返回数据结构
      getStaticPackageResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '3', name: 'data', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'creatTime', type: 'null', required: 'true', description: defaultLang === 'zh' ? '静态套餐创建时间' : 'Static package creation time' },
        { key: '5', name: 'overTime', type: 'null', required: 'true', description: defaultLang === 'zh' ? '静态套餐到期时间' : 'Static package expiration time' },
        { key: '6', name: 'uid', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '用户id' : 'User id' },
        { key: '7', name: 'username', type: 'string', required: 'true', description: defaultLang === 'zh' ? '静态套餐账号用户名' : 'Static package account username' },
        { key: '8', name: 'password', type: 'string', required: 'true', description: defaultLang === 'zh' ? '静态套餐账号密码' : 'Static package account password' },
        { key: '9', name: 'ip', type: 'string', required: 'true', description: defaultLang === 'zh' ? '静态ip' : 'Static ip' },
        { key: '10', name: 'port', type: 'string', required: 'true', description: defaultLang === 'zh' ? '静态port' : 'Static port' },
        { key: '11', name: 'iso', type: 'string', required: 'true', description: defaultLang === 'zh' ? '静态归属国家' : 'Static attribution country' }
      ],
      
      // 获取静态套餐原生的国家列表请求参数
      getStaticNativeCountryListParams: [
        { key: '1', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '用户的id' : 'User id' },
        { key: '2', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 获取静态套餐原生的国家列表返回数据结构
      getStaticNativeCountryListResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '3', name: 'data', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'country', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家英文全称' : 'Full English name of the country' },
        { key: '5', name: 'countryZh', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家中文' : 'Chinese name of the country' },
        { key: '6', name: 'countryCode', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家码' : 'Country code' }
      ],
      
      // 获取静态套餐广播的国家列表请求参数
      getStaticBroadcastCountryListParams: [
        { key: '1', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '用户uid' : 'User uid' },
        { key: '2', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 获取静态套餐广播的国家列表返回数据结构
      getStaticBroadcastCountryListResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '3', name: 'data', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'country', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家英文全称' : 'Full English name of the country' },
        { key: '5', name: 'countryZh', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家中文' : 'Chinese name of the country' },
        { key: '6', name: 'countryCode', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家码' : 'Country code' }
      ],
      
      // 根据国家查询城市列表请求参数
      getStaticCityListParams: [
        { key: '1', name: 'uid', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '账户的id' : 'Account id' },
        { key: '2', name: 'country_code', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '国家代码' : 'Country code' },
        { key: '3', name: 'proxies_format', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '代理格式 默认 2' : 'Proxy format default 2' },
        { key: '4', name: 'proxies_type', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '代理类型 Premium (ISP) proxies为原生 Shared (ISP) proxies为广播 使用原生国家就用前者，使用广播国家就用后者' : 'Proxy type Premium (ISP) proxies are native Shared (ISP) proxies are broadcast use the former for native countries, use the latter for broadcast countries' },
        { key: '5', name: 'purpose_web', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '目标网站' : 'Target website' },
        { key: '6', name: 'sign', location: 'query', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 根据国家查询城市列表返回数据结构
      getStaticCityListResponseData: [
        { key: '1', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' },
        { key: '2', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '3', name: 'data', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '返回数据' : 'Return data' },
        { key: '4', name: 'proxies_type', type: 'string', required: 'true', description: defaultLang === 'zh' ? '代理类型' : 'Proxy type' },
        { key: '5', name: 'proxies_format', type: 'string', required: 'true', description: defaultLang === 'zh' ? '代理格式' : 'Proxy format' },
        { key: '6', name: 'purpose_web', type: 'string', required: 'true', description: defaultLang === 'zh' ? '目标网站' : 'Target website' },
        { key: '7', name: 'country_list', type: '[object]', required: 'true', description: defaultLang === 'zh' ? '城市列表' : 'City list' },
        { key: '8', name: 'continents_name', type: 'string', required: 'true', description: defaultLang === 'zh' ? '大陆名称' : 'Continent name' },
        { key: '9', name: 'country_code', type: 'string', required: 'true', description: defaultLang === 'zh' ? '国家代码' : 'Country code' },
        { key: '10', name: 'city_id', type: 'string', required: 'true', description: defaultLang === 'zh' ? '城市id' : 'City id' },
        { key: '11', name: 'city_name', type: 'string', required: 'true', description: defaultLang === 'zh' ? '城市名称' : 'City name' },
        { key: '12', name: 'number', type: 'string', required: 'true', description: defaultLang === 'zh' ? '该城市下目标网址的对应库存' : 'Corresponding inventory of the target website under this city' }
      ],
      
      // 购买原生静态住宅请求参数
      purchaseStaticPackageNativeParams: [
        { key: '1', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '登录用户的id' : 'Logged-in user id' },
        { key: '2', name: 'count', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '购买静态套餐的数量' : 'Number of static packages to purchase' },
        { key: '3', name: 'protocolsType', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '静态套餐的协议类型 1=http 2=socks5' : 'Protocol type of the static package 1=http 2=socks5' },
        { key: '4', name: 'country', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '国家对应的code码（传原生国家列表下对应的国家码）' : 'Code corresponding to the country (pass the country code under the native country list)' },
        { key: '5', name: 'cityName', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '城市名称（传原生城市列表下对应的城市名称）' : 'City name (pass the city name under the native city list)' },
        { key: '6', name: 'timePeriod', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '购买套餐的天数 目前只支持传30' : 'Number of days to purchase the package, currently only support passing 30' },
        { key: '7', name: 'purposeWeb', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '目标网站' : 'Target website' },
        { key: '8', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 购买广播静态住宅请求参数
      purchaseStaticPackageBroadcastParams: [
        { key: '1', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '登录用户的id' : 'Logged-in user id' },
        { key: '2', name: 'count', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '购买静态套餐的数量' : 'Number of static packages to purchase' },
        { key: '3', name: 'protocolsType', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '静态套餐的协议类型 1=http 2=socks5' : 'Protocol type of the static package 1=http 2=socks5' },
        { key: '4', name: 'country', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '国家对应的code码（传广播国家列表下对应的国家码）' : 'Code corresponding to the country (pass the country code under the broadcast country list)' },
        { key: '5', name: 'cityName', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '城市名称（传广播城市列表下对应的城市名称）' : 'City name (pass the city name under the broadcast city list)' },
        { key: '6', name: 'timePeriod', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '购买套餐的天数 目前只支持传30' : 'Number of days to purchase the package, currently only support passing 30' },
        { key: '7', name: 'purposeWeb', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '目标网站' : 'Target website' },
        { key: '8', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 续费静态住宅请求参数
      pointRenewalStaticPackageParams: [
        { key: '1', name: 'uid', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '登录用户的id' : 'Logged-in user id' },
        { key: '2', name: 'ips', location: 'body', type: 'Array[string]', required: '是', description: defaultLang === 'zh' ? '购买静态套餐的IP数组' : 'IP array of purchased static packages' },
        { key: '3', name: 'num', location: 'body', type: 'integer', required: '是', description: defaultLang === 'zh' ? '续费的天数 目前只支持传30' : 'Number of days to renew, currently only support passing 30' },
        { key: '4', name: 'sign', location: 'body', type: 'string', required: '是', description: defaultLang === 'zh' ? '签名' : 'Signature' }
      ],
      
      // 通用返回数据结构
      commonResponseData: [
        { key: '1', name: 'msg', type: 'string', required: 'true', description: defaultLang === 'zh' ? '消息' : 'Message' },
        { key: '2', name: 'code', type: 'integer', required: 'true', description: defaultLang === 'zh' ? '状态码' : 'Status code' }
      ]
    };
  },
  methods: {
    // 可以在这里添加需要的方法
  }
};
</script>

<style scoped>
.api-documentation {
  padding: 20px;
}

.api-detail {
  margin-top: 20px;
}

.api-path {
  font-family: monospace;
  color: #1890ff;
  margin-bottom: 10px;
  font-size: 16px;
}

.api-signature {
  background-color: #fff8e6;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
}
</style>